'use client';

import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { Text } from '../../components/Text/text';

export const FormRecapError: React.FC = () => {
  const label = useLabel();

  return (
    <div className="llm__row">
      <div className="llm__col --sm-10 --md-8 --lg-6">
        <Text body={label('llm.formRecapError')} />
      </div>
    </div>
  );
};
